import React, { useEffect } from "react";
import "./superedit.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../Global/topbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SuperEditForm from "./SuperEditForm";

export default function SuperEdit() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { data, edit2 } = state || {};

  useEffect(() => {
    if (!data) {
      navigate("/admin/super_admin", { replace: true });
    }
  }, [data, navigate]);

  if (!data) {
    return null;
  }

  return (
    <div className="admin-main">
      <div className="admin-container">
        <Topbar />
        <div className="admin-mid4">
          <div className="backbutton">
            <button
              onClick={() => {
                navigate("/admin/super_admin");
              }}
              className="logout"
            >
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>{" "}
            <h1>Admin Details</h1>
          </div>
          <div className="link">
            <button className="a-button" style={{ display: "none" }}>
              Dashboard
            </button>{" "}
            <Link to="/admin/super_admin">Admin List</Link> &#62;{" "}
            <a href={window.location.href}> Admin Details</a>
          </div>
        </div>
        <SuperEditForm data={data} edit2={edit2} />
      </div>
    </div>
  );
}
